import React, { useState } from "react";
import { Box, Typography, Divider } from "@mui/material";
import { useTranslationContext } from "../../../hooks/translations/translationsProvider";
import { UserInfosModel } from "../../../models/user/UserInfosModel";
import AssociationPrivateUsersTable from "./AssociationPrivateUserTable";
import AdminPrivateUser from "../Admin/Users/AdminPrivateUser";
import AssociationPrivateUser from "./AssociationPrivateUser";
import { GREEN_MAIN } from "../../../theme/colors";



const AssociationUserManagement: React.FC = () => {
    const {t} = useTranslationContext();
    const [selectedAssociationPrivateUser, setSelectedAssociationPrivateUser] = useState<UserInfosModel | null>(null);
    return (
        <Box >
            <Typography variant="h3" gutterBottom sx={{ color: GREEN_MAIN, paddingBottom:5}}>
                {t("Gestione Utenti")}
            </Typography>
            
            {!selectedAssociationPrivateUser ? 
                (
                    <>

                        <AssociationPrivateUsersTable onUserSelect={setSelectedAssociationPrivateUser}/>

                    </>
                ):(
                    <AssociationPrivateUser
                        user={selectedAssociationPrivateUser}
                        onBack={() => setSelectedAssociationPrivateUser(null)}
                    />
                )
            }
        </Box>
    );
};

export default AssociationUserManagement;
